module.exports = __webpack_public_path__ + "img/Profile Pic - mcmastersolarcar.dff0c8c3.jpg";